import gql from 'graphql-tag';

const updateAuctionAccessBlacklistMutation = gql`
  mutation updateAuctionAccessBlacklist(
    $input: UpdateAuctionAccessBlacklistInput!
  ) {
    updateAuctionAccessBlacklist(input: $input) {
      success
      errors
    }
  }
`;

export default updateAuctionAccessBlacklistMutation;
